/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Method_Learn_More_AboutInputs */

const en_method_learn_more_about = /** @type {(inputs: Method_Learn_More_AboutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Learn more about ${i?.title}`)
};

const es_method_learn_more_about = /** @type {(inputs: Method_Learn_More_AboutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Saber más sobre ${i?.title}`)
};

const de_method_learn_more_about = /** @type {(inputs: Method_Learn_More_AboutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erfahren Sie mehr über ${i?.title}`)
};

const zh_method_learn_more_about = /** @type {(inputs: Method_Learn_More_AboutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`了解有关 ${i?.title} 的更多信息`)
};

const ar_method_learn_more_about = /** @type {(inputs: Method_Learn_More_AboutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`اعرف المزيد عن ${i?.title}`)
};

const fr_method_learn_more_about = /** @type {(inputs: Method_Learn_More_AboutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`En savoir plus sur ${i?.title}`)
};

const vi_method_learn_more_about = /** @type {(inputs: Method_Learn_More_AboutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tìm hiểu thêm về ${i?.title}`)
};

const sw_method_learn_more_about = /** @type {(inputs: Method_Learn_More_AboutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pata maelezo zaidi kuhusu ${i?.title}`)
};

const th_method_learn_more_about = /** @type {(inputs: Method_Learn_More_AboutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เรียนรู้เพิ่มเติมเกี่ยวกับ ${i?.title}`)
};

const bs_method_learn_more_about = /** @type {(inputs: Method_Learn_More_AboutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Saznajte više o ${i?.title}`)
};

const ja_method_learn_more_about = /** @type {(inputs: Method_Learn_More_AboutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}についてもっと知る`)
};

const ko_method_learn_more_about = /** @type {(inputs: Method_Learn_More_AboutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}에 대해 자세히 알아보기`)
};

const pt_method_learn_more_about = /** @type {(inputs: Method_Learn_More_AboutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Saiba mais sobre o ${i?.title}`)
};

const it_method_learn_more_about = /** @type {(inputs: Method_Learn_More_AboutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Scopri di più su ${i?.title}`)
};

const sv_method_learn_more_about = /** @type {(inputs: Method_Learn_More_AboutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Läs mer om ${i?.title}`)
};

const nl_method_learn_more_about = /** @type {(inputs: Method_Learn_More_AboutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Meer informatie over ${i?.title}`)
};

const da_method_learn_more_about = /** @type {(inputs: Method_Learn_More_AboutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Læs mere om ${i?.title}`)
};

const nb_method_learn_more_about = /** @type {(inputs: Method_Learn_More_AboutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lær mer om ${i?.title}`)
};

const fi_method_learn_more_about = /** @type {(inputs: Method_Learn_More_AboutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lisätietoja ${i?.title}:stä`)
};

const pl_method_learn_more_about = /** @type {(inputs: Method_Learn_More_AboutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dowiedz się więcej o ${i?.title}`)
};

const ru_method_learn_more_about = /** @type {(inputs: Method_Learn_More_AboutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Узнайте больше о ${i?.title}`)
};

const tr_method_learn_more_about = /** @type {(inputs: Method_Learn_More_AboutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} hakkında daha fazla bilgi edinin`)
};

const hi_method_learn_more_about = /** @type {(inputs: Method_Learn_More_AboutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const id_method_learn_more_about = /** @type {(inputs: Method_Learn_More_AboutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pelajari lebih lanjut tentang ${i?.title}`)
};

const ms_method_learn_more_about = /** @type {(inputs: Method_Learn_More_AboutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ketahui lebih lanjut tentang ${i?.title}`)
};

const cs_method_learn_more_about = /** @type {(inputs: Method_Learn_More_AboutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Více informací o ${i?.title}`)
};

const el_method_learn_more_about = /** @type {(inputs: Method_Learn_More_AboutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Μάθετε περισσότερα για το ${i?.title}`)
};

const he_method_learn_more_about = /** @type {(inputs: Method_Learn_More_AboutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`קראו עוד על ${i?.title}`)
};

const af_method_learn_more_about = /** @type {(inputs: Method_Learn_More_AboutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Leer meer oor ${i?.title}`)
};

const hu_method_learn_more_about = /** @type {(inputs: Method_Learn_More_AboutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bővebb információ az ${i?.title}-ről`)
};

/**
* | output |
* | --- |
* | "Learn more about {title}" |
*
* @param {Method_Learn_More_AboutInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_learn_more_about = /** @type {((inputs: Method_Learn_More_AboutInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Learn_More_AboutInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_learn_more_about(inputs)
	if (locale === "de") return de_method_learn_more_about(inputs)
	if (locale === "zh") return zh_method_learn_more_about(inputs)
	if (locale === "ar") return ar_method_learn_more_about(inputs)
	if (locale === "fr") return fr_method_learn_more_about(inputs)
	if (locale === "vi") return vi_method_learn_more_about(inputs)
	if (locale === "sw") return sw_method_learn_more_about(inputs)
	if (locale === "th") return th_method_learn_more_about(inputs)
	if (locale === "bs") return bs_method_learn_more_about(inputs)
	if (locale === "ja") return ja_method_learn_more_about(inputs)
	if (locale === "ko") return ko_method_learn_more_about(inputs)
	if (locale === "pt") return pt_method_learn_more_about(inputs)
	if (locale === "it") return it_method_learn_more_about(inputs)
	if (locale === "sv") return sv_method_learn_more_about(inputs)
	if (locale === "nl") return nl_method_learn_more_about(inputs)
	if (locale === "da") return da_method_learn_more_about(inputs)
	if (locale === "nb") return nb_method_learn_more_about(inputs)
	if (locale === "fi") return fi_method_learn_more_about(inputs)
	if (locale === "pl") return pl_method_learn_more_about(inputs)
	if (locale === "ru") return ru_method_learn_more_about(inputs)
	if (locale === "tr") return tr_method_learn_more_about(inputs)
	if (locale === "hi") return hi_method_learn_more_about(inputs)
	if (locale === "id") return id_method_learn_more_about(inputs)
	if (locale === "ms") return ms_method_learn_more_about(inputs)
	if (locale === "cs") return cs_method_learn_more_about(inputs)
	if (locale === "el") return el_method_learn_more_about(inputs)
	if (locale === "he") return he_method_learn_more_about(inputs)
	if (locale === "af") return af_method_learn_more_about(inputs)
	if (locale === "hu") return hu_method_learn_more_about(inputs)
	return en_method_learn_more_about(inputs)
});